<template>
  <q-page class="q-pa-md bg-grey-2">
    <!-- NAVEGACIÓN Y BREADCRUMBS -->
    <div class="row items-center justify-between q-mb-md">
      <q-breadcrumbs active-color="primary" style="font-size: 14px">
        <q-breadcrumbs-el label="Inicio" icon="home" to="/aveo/Dashboard" />
        <q-breadcrumbs-el label="Empresas" icon="business" to="/aveo/Empresa/Lista" />
        <q-breadcrumbs-el label="Nueva Empresa" icon="add" />
      </q-breadcrumbs>

      <q-btn
        outline
        color="primary"
        icon="arrow_back"
        label="Volver a Lista"
        no-caps
        class="bg-white"
        @click="$router.push('/aveo/Empresa/Lista')"
      />
    </div>

    <q-card class="shadow-2 rounded-borders">
      <q-card-section class="bg-primary text-white row items-center justify-between q-py-md">
        <div class="text-h6 text-weight-bold row items-center">
          <q-icon name="business" class="q-mr-sm" size="sm" />
          Registrar Nueva Empresa
        </div>
      </q-card-section>

      <q-card-section class="q-pa-md">
        <q-form @submit.prevent="GuardarCliente" class="q-gutter-y-md">
          <div class="row q-col-gutter-md">
            <div class="col-12 col-sm-6">
              <q-input
                v-model="NuevaData.ruc"
                label="RUC *"
                outlined
                dense
                :rules="[val => !!val || 'RUC es requerido']"
              />
            </div>
            <div class="col-12 col-sm-6">
              <q-input
                v-model="NuevaData.razonsocial"
                label="Razón Social *"
                outlined
                dense
                :rules="[val => !!val || 'Razón Social es requerida']"
              />
            </div>
          </div>

          <q-input
            v-model="NuevaData.descripcion"
            label="Descripción"
            outlined
            dense
          />

          <div class="row q-col-gutter-md">
            <div class="col-12 col-sm-6">
              <q-input
                v-model="NuevaData.representante"
                label="Representante"
                outlined
                dense
              />
            </div>
            <div class="col-12 col-sm-6">
              <q-input
                v-model="NuevaData.telefono"
                label="Teléfono"
                outlined
                dense
              />
            </div>
          </div>

          <div class="row q-col-gutter-md">
            <div class="col-12 col-sm-6">
              <q-input
                v-model="NuevaData.direccion"
                label="Dirección"
                outlined
                dense
              />
            </div>
            <div class="col-12 col-sm-6">
              <q-input
                v-model="NuevaData.email"
                label="Correo Electrónico"
                outlined
                dense
              />
            </div>
          </div>

          <div class="row q-col-gutter-md">
            <div class="col-12 col-sm-6">
              <q-select
                v-model="NuevaData.estado"
                :options="[
                  { label: 'Vigente', value: 'V' },
                  { label: 'Anulado', value: 'A' }
                ]"
                option-value="value"
                option-label="label"
                emit-value
                map-options
                label="Estado"
                outlined
                dense
              />
            </div>
          </div>

          <div class="row justify-end q-gutter-sm q-pt-md">
            <q-btn
              flat
              label="Cancelar"
              color="grey-7"
              no-caps
              @click="$router.push('/aveo/Empresa/Lista')"
            />
            <q-btn
              type="submit"
              color="primary"
              label="Guardar Empresa"
              icon="save"
              unelevated
              no-caps
              :loading="isLoading"
              :disable="EstadoBoton"
              class="text-weight-bold"
            />
          </div>
        </q-form>
      </q-card-section>
    </q-card>
  </q-page>
</template>

<script>
import axios from "axios";
export default {
  name: "EmpresaNuevoPage",
  data() {
    return {
      isLoading: false,
      EstadoBoton: false,
      NuevaData: {
        ruc: "",
        razonsocial: "",
        representante: "",
        telefono: "",
        direccion: "",
        descripcion: "",
        email: "",
        estado: "V",
      },
    };
  },
  methods: {
    GuardarCliente() {
      let me = this;
      this.isLoading = true;
      this.EstadoBoton = true;
      axios({
        method: "post",
        url: "ApiWeb/EmpresaAgregar.php",
        data: me.NuevaData,
      })
        .then((response) => {
          if (response.data && response.data.estado == "ERROR") {
            this.notificar(response.data.mensaje, "warning");
          } else {
            this.notificar((response.data && response.data.mensaje) || "Empresa guardada exitosamente", "positive");
            this.$router.push("/aveo/Empresa/Lista");
          }
        })
        .catch((error) => {
          console.error(error);
          this.notificar("Error al guardar empresa", "negative");
        })
        .finally(() => {
          this.isLoading = false;
          this.EstadoBoton = false;
        });
    },
    notificar(msg, color) {
      if (this.$q && this.$q.notify) {
        this.$q.notify({
          message: msg,
          color: color,
          position: "top-right",
          timeout: 3000
        });
      } else {
        alert(msg);
      }
    }
  },
};
</script>
